import type {ContextPanelDataWithCondition} from 'common/widgets/context-panel/types';
import {getReportName} from 'common/report/util';
import {ReportName, SPECIAL_EVENTS} from 'common/report/constants';

// TODO: add all other special events to the list
export const SPECIAL_EVENT_CONTEXT_TOOLTIP_DATA: ContextPanelDataWithCondition[] = [
  {
    header: `Selected Step`,
    entityName: SPECIAL_EVENTS.SELECTED_STEP,
    description: `Refers to the first step in the step range selection.`,
  },
  {
    header: `All Events`,
    entityName: SPECIAL_EVENTS.ALL_EVENTS,
    description: `All events in the project, excluding hidden events.`,
    condition: () => {
      // The All Events special event behaves differently in the Events report.
      return getReportName() !== ReportName.Events;
    },
  },
];
